import { useState } from "react";
import { RouteFactory } from "@app/routePaths";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { Loading } from "@components/LoadMore/LoadMore";
import { cn } from "@util/helpers";

type ArticleSummariseButtonProps = {
  /** The unique identifier for the article */
  articleId: string;
  /** Boolean indicating if a summary is available for the article */
  isSummaryAvailable?: boolean;
  /** Optional additional CSS classes for styling */
  className?: string;
};

/**
 * A button component that navigates to the Pulse summary page for a given article.
 * https://www.figma.com/design/Z4TodR7tmA9YZuZjMSuU9I/PULSE--WEB-?node-id=5925-38325&t=U87o4WAHpGkLntoR-1
 */
const ArticleSummariseButton = ({
  articleId,
  isSummaryAvailable,
  className,
}: ArticleSummariseButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!isSummaryAvailable) return <></>;

  const handleNavigateToPulse = () => {
    setIsLoading(true);
    sessionStorage.setItem("pulse_back_path", location.pathname);
  };

  const link = `${RouteFactory.pulseSlide(articleId)}?ref=pulse-article-top`;

  return (
    <>
      <ButtonFactory
        mask={ButtonType.Secondary}
        buttonType={ButtonType.Link}
        text="Summarise"
        link={link}
        iconPosition="left"
        icon={<IconFactory type={IconTypeEnum.summarise} />}
        className={cn("items-center gap-2 p-2 leading-150", className)}
        onClick={handleNavigateToPulse}
        target="_self"
      />

      <Loading isLoading={isLoading} />
    </>
  );
};

export default ArticleSummariseButton;
